const clipboard = (value = '') => {
  navigator.clipboard.writeText(value);
};

export default clipboard;
